import React, { useCallback } from 'react';

import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import BaseMainMenuLink from 'components/main-menu-link';
import useLocation from 'hooks/location/use-location';
import { primitive } from 'styles/constants/primitives';
import { routes } from 'utils/routing';

import { IMainMenuLink } from './types';

const LinkContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  z-index: ${Styles.zIndex.top};

  ${Styles.desktop`
    margin: ${primitive.$spacing7} 6rem;
    position: relative;
    z-index: 1;
  `}
`;

const MainMenuLink: React.FC<IMainMenuLink> = ({ backToFullMenu }) => {
  const { back, location } = useLocation();
  const isMenu = location.pathname.startsWith(routes.menu);
  const navigate = useNavigate();
  const onClickCallBack = backToFullMenu ? () => navigate(routes.menu) : back;

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      if (isMenu) {
        onClickCallBack();
        e.preventDefault();
      }
    },
    [isMenu, onClickCallBack]
  );
  return (
    <LinkContainer data-testid="main-menu-link-container">
      <BaseMainMenuLink onClick={onClick} />
    </LinkContainer>
  );
};
export default MainMenuLink;
